// extracted by mini-css-extract-plugin
export default {"delete":"DeleteVolunteer_delete__9lT06"};